import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
const PrivacyPolicy = ({ navigateToHome, navigateToBlog, navigateToB2B, backendUrl, navigateToPrivacy, navigateToTerms, navigateToAbout, navigateToSitemap }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [privacyData, setPrivacyData] = useState({ title: '', content: '' });
  const [loading, setLoading] = useState(true);

  // Load privacy data from API
  useEffect(() => {
    const loadPrivacyData = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/legal/privacy`);
        if (response.ok) {
          const data = await response.json();
          setPrivacyData({
            title: data.title || 'Adatvédelmi és Cookie Tájékoztató',
            content: data.content || '<p>Tartalom betöltése...</p>'
          });
        }
      } catch (error) {
        console.error('Hiba az adatvédelmi tájékoztató betöltése során:', error);
        setPrivacyData({
          title: 'Adatvédelmi és Cookie Tájékoztató',
          content: '<p>Hiba történt a tartalom betöltése során.</p>'
        });
      } finally {
        setLoading(false);
      }
    };

    loadPrivacyData();
  }, []);

  // SEO setup for Privacy Policy page
  useEffect(() => {
    document.title = `${privacyData.title} - FogPortál.hu`;
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.getElementsByTagName('head')[0].appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'FogPortál.hu Adatvédelmi és Cookie Tájékoztató. Személyes adatok kezelése, GDPR megfelelőség, cookie-k használata.');
    
    return () => {
      document.title = "FogPortál.hu - Magyarország prémium fogászati portálja";
    };
  }, [privacyData.title]);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Adatvédelmi tájékoztató – FogPortál.hu"
        description="A FogPortál.hu adatvédelmi tájékoztatója. Ismerje meg, hogyan kezeljük személyes adatait."
        canonicalUrl={`${window.location.origin}/adatvedelem`}
        noindex={true}
      />
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex items-center">
              <button 
                onClick={navigateToHome}
                className="flex items-center space-x-3"
              >
                <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-green-600 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 2.21 1.79 4 4 4s4-1.79 4-4v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 15c0 1.1-.9 2-2 2s-2-.9-2-2v-1h4v1zm1.46-4.86C14.8 12.64 14 13.26 14 14v1h-4v-1c0-.74-.8-1.36-1.46-.86C7.06 12.5 6 10.84 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.84-1.06 3.5-2.54 4.14z"/>
                  </svg>
                </div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  FogPortál.hu
                </h1>
              </button>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex items-center space-x-1">
              <button 
                onClick={navigateToHome}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium text-sm transition-all duration-200"
              >
                Főoldal
              </button>
              <button 
                onClick={navigateToB2B}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium text-sm transition-all duration-200"
              >
                Megjelenés fogászatoknak
              </button>
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-lg text-gray-600 hover:text-blue-600 hover:bg-gray-50"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        {/* Mobile menu dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-2 pt-4 px-4">
              <button 
                onClick={() => {
                  navigateToHome();
                  setIsMobileMenuOpen(false);
                }}
                className="px-4 py-3 text-left text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium transition-all duration-200"
              >
                Főoldal
              </button>
              <button 
                onClick={() => {
                  navigateToB2B();
                  setIsMobileMenuOpen(false);
                }}
                className="px-4 py-3 text-left text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium transition-all duration-200"
              >
                Megjelenés fogászatoknak
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600">Tartalom betöltése...</span>
          </div>
        ) : (
          <div className="prose prose-lg max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">{privacyData.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: privacyData.content }} />
            
            <div className="text-center mt-12">
              <button 
                onClick={navigateToHome}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
              >
                Vissza a főoldalra
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// AboutUs Component

export default PrivacyPolicy;
